import ChartDocumentProvider from "./ChartDocumentProvider";
import DirectorySearchProvider from "./DirectorySearchProvider";
import FileManagerProvider from "./FileManagerProvider";
import NavigationProvider from "./NavigationProvider";
import RightSidebarProvider from "./RightSidebarProvider";
import ViewManagerProvider from "./ViewManagerProvider";
import WsMgrProvider from "./WsMgrProvider";
import PlanManagerProvider from "@/providers/PlanManagerProvider";
import TableManagerProvider from "@/providers/AppendTableProvider";
import ContextMenuProvider from "@/providers/ContextMenuProvider";
import ReportsProvider from "@/providers/ReportsProvider";
import RecordInfoProvider from "@/providers/RecordInfoProvider";
import { BlockerProvider } from "./BlockerProvider";
import { ToastProvider } from "@/providers/ToastProvider";
import ChartSettingsProvider from "@/providers/ChartSettingsProvider";
import AccountSettingsProvider from "@/providers/AccountSettingsProvider";

const Providers = props => (
  <WsMgrProvider>
    <ToastProvider>
      <ContextMenuProvider>
        <ChartDocumentProvider>
          <BlockerProvider>
            <AccountSettingsProvider>
              <ChartSettingsProvider>
                <RightSidebarProvider>
                  <ViewManagerProvider>
                    <DirectorySearchProvider>
                      <PlanManagerProvider>
                        <NavigationProvider>
                          <ReportsProvider>
                            <TableManagerProvider>
                              <RecordInfoProvider>
                                <FileManagerProvider>{props.children}</FileManagerProvider>
                              </RecordInfoProvider>
                            </TableManagerProvider>
                          </ReportsProvider>
                        </NavigationProvider>
                      </PlanManagerProvider>
                    </DirectorySearchProvider>
                  </ViewManagerProvider>
                </RightSidebarProvider>
              </ChartSettingsProvider>
            </AccountSettingsProvider>
          </BlockerProvider>
        </ChartDocumentProvider>
      </ContextMenuProvider>
    </ToastProvider>
  </WsMgrProvider>
);

export default Providers;
